import { ListItemButton, styled } from "@mui/material";

const ProjectListButton = styled(ListItemButton)(() => ({
  borderRadius: "1.5rem",
  padding: 0,
  overflow: "hidden",
}));

export default ProjectListButton;
